import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
//import Snackbar from '@material-ui/core/Snackbar';
import { Topbar } from "./components";
//import { onMessageListener } from '../../common/firebase';

const useStyles = makeStyles(() => ({
  root: {
    height: "100%",
  },
  content: {
    height: "100%",
  },
}));

const MinimalNoHeader = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <main className={classes.content}>{children}</main>
    </div>
  );
};

MinimalNoHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default MinimalNoHeader;
